import { Link } from 'react-router-dom'
import { Modal } from '../ui/Modal'
import CustomButton from '../ui/CustomButton'

const SubscriptionBlockModal = ({ isOpen, config, onClose, onSecondaryClick, onPrimaryClick }) => {
  if (!config) return null

  const handleBackdrop = config.closable ? onClose : () => {}

  return (
    <Modal isOpen={isOpen} onClose={handleBackdrop}>
      <div className='bg-white rounded-xl shadow-lg p-6 w-full max-w-md'>
        <h2 className='text-lg font-bold mb-4'>{config.title}</h2>
        <p className='mb-6 text-sm text-gray-700'>{config.body}</p>
        <div className='flex gap-3 justify-end'>
          {config.secondaryLabel && (
            <CustomButton
              className='rounded-full'
              color='primary'
              onClick={onSecondaryClick}
              title={config.secondaryLabel}
            />
          )}
          {onPrimaryClick ? (
            <CustomButton
              className='rounded-full'
              color='accent2'
              onClick={onPrimaryClick}
              title={config.primaryLabel}
            />
          ) : (
            <Link to={config.primaryTo}>
              <CustomButton
                className='rounded-full'
                color='accent2'
                title={config.primaryLabel}
              />
            </Link>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default SubscriptionBlockModal
